












import LoaderService from '@/app/shared/utils/loader.service';
import { UnitList } from '@/app/shared/models/calculations/UnitList';
import { SingleImpact } from '@/app/shared/models/reports/SingleImpact';
import { ModuleProperties } from '@/app/shared/models/Module';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const ReportsStore = namespace('Reports');
const LibraryStore = namespace('Library');
const CalculationsStore = namespace('Calculations');
const ModulePropertiesStore = namespace('ModuleProperties');

@Component({
  components: {},
})
export default class SingleImpactNavigationBar extends Vue {
  @ModulePropertiesStore.Getter
  moduleProperties: ModuleProperties;

  @ReportsStore.Getter
  getSingleImpact!: SingleImpact;

  @ReportsStore.Action
  public initializeSingleImpact!: (payload: {
    uuid: string;
    studyUuid: string;
    fromMatrix: string;
    cumulative: boolean;
  }) => Promise<any>;

  @ReportsStore.Action
  public expandAllInContent!: (shouldExpand: boolean) => Promise<void>;

  @CalculationsStore.Getter
  getUnitList: UnitList;

  @CalculationsStore.Getter
  getProcessorUrl: string;

  @CalculationsStore.Action
  initializeProcessorUrl: (url: string) => Promise<void>;

  @LibraryStore.Action
  addSingleImpactToLibrary: (payload: {
    uuid: string;
    studyUuid: string;
    fromMatrix: boolean;
    cumulative: boolean;
  }) => Promise<any>;

  hasBack() {
    return this.getIndex() ? true : false;
  }

  async back() {
    const previous = this.getIndex() - 1;
    const urlParts = this.$route.fullPath.split('/');
    if (this.getUnitList?.children[previous]) {
      urlParts[3] = this.getUnitList?.children[previous].uuid;

      this.$router.push(urlParts.join('/'));

      LoaderService.disableHttpLoader();
      await this.initializeSingleImpact({
        uuid: this.getUnitList?.children[previous].uuid,
        studyUuid: this.$route.params.studyUuid,
        fromMatrix: this.$route.query.fromMatrix as string,
        cumulative: this.$route.query.cumulative === 'true',
      });
      this.expandAllInContent(true);
      LoaderService.enableHttpLoader();
    }
  }

  hasRoot() {
    return this.getProcessorUrl ? true : false;
  }

  backToRoot() {
    this.$router.push(this.getProcessorUrl);
  }

  hasNext() {
    const largestIndex = this.getUnitList?.children.length - 1;
    return this.getIndex() < largestIndex ? true : false;
  }

  async next() {
    const next = this.getIndex() + 1;
    const urlParts = this.$route.fullPath.split('/');
    if (this.getUnitList?.children[next]) {
      urlParts[3] = this.getUnitList?.children[next].uuid;

      this.$router.push(urlParts.join('/'));

      LoaderService.disableHttpLoader();
      await this.initializeSingleImpact({
        uuid: this.getUnitList?.children[next].uuid,
        studyUuid: this.$route.params.studyUuid,
        fromMatrix: this.$route.query.fromMatrix as string,
        cumulative: this.$route.query.cumulative === 'true',
      });
      this.expandAllInContent(true);
      LoaderService.enableHttpLoader();
    }
  }

  getIndex() {
    return this.getUnitList?.children.findIndex((el) => el.uuid === this.getSingleImpact.unit.uuid);
  }

  async addToLibrary() {
    const payload = {
      uuid: this.getSingleImpact.unit.uuid,
      studyUuid: this.moduleProperties.study_uuid,
      fromMatrix: false,
      cumulative: this.$route.query.cumulative == 'true',
    };

    try {
      await this.addSingleImpactToLibrary(payload);
    } catch (error) {
      console.error(error);
    }
  }
}
